import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import HistoryIcon from '@mui/icons-material/History';

/**
 * NoteActions Component
 * 
 * Displays action buttons for creating, saving, and viewing past notes
 * 
 * @param {boolean} isSaving - Whether a save operation is in progress
 * @param {boolean} readOnly - Whether the note is in read-only mode
 * @param {Function} onNewNote - Handler for creating a new note
 * @param {Function} onSaveNote - Handler for saving the current note
 * @param {Function} onShowPastNotes - Handler for showing past notes
 * @returns {JSX.Element} - The rendered component
 */
const NoteActions = ({
  isSaving,
  readOnly,
  onNewNote,
  onSaveNote,
  onShowPastNotes
}) => {
  return (
    <div className='note-actions'>
      <IconButton
        onClick={onNewNote}
        title='New Note'
        disabled={isSaving}
        size="medium"
        color="primary"
        className='new-note-button'
      >
        <AddIcon />
      </IconButton>
      
      <IconButton
        onClick={onSaveNote}
        disabled={isSaving || readOnly}
        title='Save Note'
        size="medium"
        color="primary"
        className='save-note-button'
      >
        {isSaving ? <CircularProgress size={20} /> : <SaveIcon />}
      </IconButton>
      
      <IconButton
        onClick={onShowPastNotes}
        title='Past Notes'
        size="medium"
        color="primary"
        className='past-notes-button'
      >
        <HistoryIcon />
      </IconButton>
    </div>
  );
};

NoteActions.propTypes = {
  isSaving: PropTypes.bool,
  readOnly: PropTypes.bool,
  onNewNote: PropTypes.func.isRequired,
  onSaveNote: PropTypes.func.isRequired,
  onShowPastNotes: PropTypes.func.isRequired,
};

NoteActions.defaultProps = {
  isSaving: false,
  readOnly: false,
};

export default NoteActions;
